<template>
  <v-container fill-height>
    <v-layout column>
      <v-flex xs12>
        <h1 class="display-1 my-4 text-xs-center">What Our Customers Think</h1>
        <testimonial
          v-for="(testimonial, i) in testimonials"
          :key="i"
          :testimonial="testimonial"
        ></testimonial>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { testimonials } from '../json/testimonials.json';
import Testimonial from '../components/Testimonial';

export default {
  name: 'Testimonials',
  components: { Testimonial },
  metaInfo: {
    title: 'Testimonials',
  },
  created() {
    this.testimonials = testimonials;
  },
};
</script>
